import React, {forwardRef, useEffect, useImperativeHandle, useState} from "react";
import {Input, Modal} from "antd";
import {IconClose, IconHomeSearch} from "../Icon";
import {t} from "i18next";
import Dragger from "antd/es/upload/Dragger";
import {hasLicense, imgPathPerfix, isDarkMode, isStringNullOrEmpty} from "../utils";
import "./DialogHelper.css"
import {isMacOS} from "@tiptap/core";
import {GET_ARRAY_SHORTCUTS} from "@/Const";

const DialogHelper = forwardRef((props, ref)=>{
    useImperativeHandle(ref,()=>({
        onShowDialog:onShowDialog
    }))

    const [isShowDialog,setIsShowDialog] = useState(false);
    const [searchKey,setSearchKey] = useState('');



    const [arrayShortCuts,setArrayShortCuts] = useState(GET_ARRAY_SHORTCUTS());
    const [rightName,setRightName] = useState(t('Tool'));

    const onShowDialog = ()=>{
        setSearchKey('');
        const arrayShortCuts = GET_ARRAY_SHORTCUTS();
        if (isMacOS()){
            arrayShortCuts.forEach(p=>{
                p.children.forEach(item=>{
                    item.key = item.key.replaceAll("Ctrl","⌘").replaceAll("Alt","Opt");
                })
            })
        }
        setArrayShortCuts(arrayShortCuts);
        setIsShowDialog(true);
    }

    useEffect(()=>{

    },[])

    const renderRightPart = ()=>{
        const item:any = arrayShortCuts.find(p=>p.isChecked);
        return(
            <>
                {
                    item?.children?.map(p=> (
                        <div className={'dialog-title'} style={{
                            borderBottom: '1px solid var(--dialog-help-item-line-color)',
                            width: '100%',
                            display: 'flex',
                            alignItems:'center',
                            height: '42px'
                        }}>
                            <span style={{display:'block',flexGrow:'1',color:'var(--dialog-help-item-text-color)'}}>{t(p.name)}</span>
                            {
                                p.key.split(' ').map(key=> (
                                    <span style={{
                                        background: (key == 'or')?'transparent':'var(--dialog-help-item-background-color)',
                                        height: '22px',
                                        lineHeight: '22px',
                                        padding: '0 8px',
                                        borderRadius: '4px',
                                        marginLeft:'6px',
                                    }}>{key}</span>
                                ))
                            }

                        </div>
                    ))
                }
            </>
        )
    }
    return (
        <Modal centered={true} open={isShowDialog} closable={true} closeIcon={<IconClose/>} footer={''}
               onCancel={(e) => setIsShowDialog(false)} width='668px' style={{height: 'auto'}}>
            <div className='font-size-12' style={{
                margin: '-22px',
                padding: '20px',
                height:'664px',
                flexDirection: 'column'
            }}>
                <span className='dialog-title'>{t("Keyboard shortcuts")}</span>
                <div className='line' style={{margin: '12px -16px'}}></div>
                <Input prefix={<IconHomeSearch/>} className={'input-border'}
                       suffix={<img className='img-mini-small-8 cursor-pointer mr-8' style={{display:isStringNullOrEmpty(searchKey)?"none":"inherit",
                    flexShrink:'0',height:'32px !important',
                    flexBasis:'0',
                    lineHeight:'32px'}} onClick={()=>{
                            setSearchKey('')
                           setArrayShortCuts(GET_ARRAY_SHORTCUTS());
                }} src={imgPathPerfix() + (isDarkMode() ? "close_white_1.png" : "close_black.png")}/>}
                       variant={"borderless"}
                       style={{width: '100%', height: '32px'}}
                       placeholder={t("Search for shourtcuts")} value={searchKey} onChange={(event)=>{
                        let szValue = event.currentTarget.value.toLowerCase();
                        var arrayNew:any[] = [];
                        for (let i=0;i<GET_ARRAY_SHORTCUTS().length;i++) {
                            let item = GET_ARRAY_SHORTCUTS()[i];
                            var itemChildren = [];
                            for (let j=0;j<item.children.length;j++) {
                                let child = item.children[j];
                                if (child.name.toLowerCase().indexOf(szValue) >= 0 || child.key.toLowerCase().indexOf(szValue) >= 0) {
                                    itemChildren.push(child);
                                }
                            }

                            let newItem = {
                                id:item.id,
                                name:item.name,
                                isChecked:false,
                            };
                            newItem.children = itemChildren;
                            arrayNew.push(newItem);
                        }
                        var isChecked = false;
                        for (let i=0;i<arrayNew.length;i++) {
                            if (arrayNew[i].children.length > 0) {
                                arrayNew[i].isChecked = true;
                                isChecked = true;
                                break;
                            }
                        }
                        if (!isChecked) {
                            arrayNew[0].isChecked = true;
                        }
                        setSearchKey(szValue);
                        setArrayShortCuts(arrayNew);
                }} />

                <div className={'flex-row'} style={{ width: '100%', borderRadius: '8px',marginTop:'22px'}}>
                    <div className={'left-tool-menu'}>
                        {
                            arrayShortCuts.map(p=>(
                                <div className={'flex-row-vertical-center cursor-pointer'} onClick={(e)=>{
                                    var arrayNew = [...arrayShortCuts];
                                    arrayNew.forEach(item=>item.isChecked = false);
                                    p.isChecked = true;
                                    setRightName(p.name);
                                    setArrayShortCuts(arrayNew);
                                }}
                                     style={{borderRadius:'8px',paddingLeft:'16px', height:'38px',width:'100%',background:p.isChecked?"var(--vertical-line-color)":"transparent"}}>
                                    <span className={'font-family-medium'}>{p.name}</span>
                                </div>
                            ))
                        }
                    </div>
                    <div className={'right-tool-item'}>
                        <span className={'dialog-title'} style={{
                            borderBottom: '1px solid var(--line-color)',
                            width: '100%',
                            display: 'block',
                            height: '32px'
                        }}>{rightName}</span>
                        <div style={{overflow:'auto',height:'500px',marginRight:'-22px',paddingRight:'22px'}}>
                            {
                                renderRightPart()
                            }
                        </div>

                    </div>
                </div>

            </div>
        </Modal>
    )
})

export default DialogHelper;


































